<template>
  <ContentWrap>
    <el-form
      ref="queryFormRef"
      :inline="true"
      :model="queryParams"
      class="-mb-15px"
      label-width="68px"
    >
      <el-form-item label="店铺" prop="shopId">
        <el-select
          v-model="queryParams.shopId"
          placeholder="请选择店铺"
          clearable
          filterable
          class="!w-240px"
          @change="handleQuery"
        >
          <el-option v-for="item in shopList" :key="item.id" :label="item.name" :value="item.id" />
        </el-select>
      </el-form-item>
      <el-form-item label="评分" prop="rating">
        <el-select v-model="queryParams.rating" class="!w-240px" clearable placeholder="请选择评分">
          <el-option label="5星" :value="5" />
          <el-option label="4星" :value="4" />
          <el-option label="3星" :value="3" />
          <el-option label="2星" :value="2" />
          <el-option label="1星" :value="1" />
        </el-select>
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-select v-model="queryParams.status" class="!w-240px" clearable placeholder="请选择状态">
          <el-option label="待审核" :value="0" />
          <el-option label="已发布" :value="1" />
          <el-option label="已隐藏" :value="2" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button @click="handleQuery">
          <Icon class="mr-5px" icon="ep:search" />
          搜索
        </el-button>
        <el-button @click="resetQuery">
          <Icon class="mr-5px" icon="ep:refresh" />
          重置
        </el-button>
        <el-button
          v-hasPermi="['hotel:review:create']"
          plain
          type="primary"
          @click="openForm('create')"
        >
          <Icon class="mr-5px" icon="ep:plus" />
          新增
        </el-button>
      </el-form-item>
    </el-form>
  </ContentWrap>

  <ContentWrap>
    <el-table v-loading="loading" :data="list">
      <el-table-column
        align="center"
        label="酒店"
        prop="hotelName"
        min-width="160"
        show-overflow-tooltip
      >
        <template #default="scope">{{
          scope.row.hotelName || `酒店 #${scope.row.shopId}`
        }}</template>
      </el-table-column>
      <el-table-column
        align="center"
        label="房型"
        prop="roomTypeName"
        min-width="150"
        show-overflow-tooltip
      >
        <template #default="scope">{{ scope.row.roomTypeName || '-' }}</template>
      </el-table-column>
      <el-table-column align="center" label="评分" prop="rating" min-width="120">
        <template #default="scope">
          <el-rate v-model="scope.row.rating" disabled />
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="内容"
        prop="content"
        min-width="200"
        show-overflow-tooltip
      />
      <el-table-column
        align="center"
        label="回复"
        prop="reply"
        min-width="150"
        show-overflow-tooltip
      >
        <template #default="scope">
          <el-tag v-if="scope.row.reply" type="success" size="small">已回复</el-tag>
          <el-tag v-else type="info" size="small">未回复</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" label="状态" prop="status" min-width="100">
        <template #default="scope">
          <el-tag v-if="scope.row.status === 0" type="info">待审核</el-tag>
          <el-tag v-else-if="scope.row.status === 1" type="success">已发布</el-tag>
          <el-tag v-else-if="scope.row.status === 2" type="danger">已隐藏</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        :formatter="dateFormatter"
        align="center"
        label="创建时间"
        prop="createTime"
        width="180"
      />
      <el-table-column align="center" label="操作" width="200" fixed="right">
        <template #default="scope">
          <el-button
            v-hasPermi="['hotel:review:update']"
            link
            type="primary"
            @click="openForm('update', scope.row.id)"
          >
            修改
          </el-button>
          <el-button
            v-if="!scope.row.reply"
            v-hasPermi="['hotel:review:update']"
            link
            type="success"
            @click="openReplyForm(scope.row)"
          >
            回复
          </el-button>
          <el-button
            v-hasPermi="['hotel:review:delete']"
            link
            type="danger"
            @click="handleDelete(scope.row.id)"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <Pagination
      v-model:limit="queryParams.pageSize"
      v-model:page="queryParams.pageNo"
      :total="total"
      @pagination="getList"
    />
  </ContentWrap>

  <Dialog v-model="dialogVisible" :title="dialogTitle">
    <el-form
      ref="formRef"
      v-loading="formLoading"
      :model="formData"
      :rules="formRules"
      label-width="100px"
    >
      <el-form-item label="店铺" prop="shopId">
        <el-select
          v-model="formData.shopId"
          placeholder="请选择店铺"
          clearable
          filterable
          class="!w-240px"
        >
          <el-option v-for="item in shopList" :key="item.id" :label="item.name" :value="item.id" />
        </el-select>
      </el-form-item>
      <el-form-item label="订单ID" prop="orderId">
        <el-input v-model="formData.orderId" placeholder="请输入订单ID" />
      </el-form-item>
      <el-form-item label="会员ID" prop="memberId">
        <el-input v-model="formData.memberId" placeholder="请输入会员ID" />
      </el-form-item>
      <el-form-item label="评分" prop="rating">
        <el-rate v-model="formData.rating" />
      </el-form-item>
      <el-form-item label="评价内容" prop="content">
        <el-input
          v-model="formData.content"
          :rows="4"
          placeholder="请输入评价内容"
          type="textarea"
        />
      </el-form-item>
      <el-form-item label="图片" prop="images">
        <el-input v-model="formData.images" placeholder="请输入图片地址(逗号分隔)" />
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-radio-group v-model="formData.status">
          <el-radio :value="0">待审核</el-radio>
          <el-radio :value="1">已发布</el-radio>
          <el-radio :value="2">已隐藏</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button :loading="formLoading" type="primary" @click="submitForm">确 定</el-button>
      <el-button @click="dialogVisible = false">取 消</el-button>
    </template>
  </Dialog>

  <Dialog v-model="replyDialogVisible" title="回复评价" width="500px">
    <el-form :model="replyForm" label-width="80px">
      <el-form-item label="评价内容">
        <span>{{ replyForm.content }}</span>
      </el-form-item>
      <el-form-item label="回复内容">
        <el-input
          v-model="replyForm.reply"
          :rows="4"
          placeholder="请输入回复内容"
          type="textarea"
        />
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button :loading="replyLoading" type="primary" @click="submitReply">确 定</el-button>
      <el-button @click="replyDialogVisible = false">取 消</el-button>
    </template>
  </Dialog>
</template>

<script lang="ts" setup>
import { dateFormatter } from '@/utils/formatTime'
import * as ReviewApi from '@/api/hotel/review'
import { getShopSimpleList } from '@/api/hotel/platformShop'

defineOptions({ name: 'HotelReview' })

const message = useMessage()
const { t } = useI18n()

const loading = ref(true)
const total = ref(0)
const list = ref([])

// 店铺下拉列表
const shopList = ref<any[]>([])
const getShopList = async () => {
  const data = await getShopSimpleList()
  shopList.value = data || []
}

const queryParams = reactive<any>({
  pageNo: 1,
  pageSize: 20,
  rating: undefined,
  status: undefined,
  shopId: undefined
})
const queryFormRef = ref()

const getList = async () => {
  loading.value = true
  try {
    const data = await ReviewApi.getReviewPage(queryParams)
    list.value = data.list
    total.value = data.total
  } finally {
    loading.value = false
  }
}

const handleQuery = () => {
  queryParams.pageNo = 1
  getList()
}

const resetQuery = () => {
  queryFormRef.value.resetFields()
  handleQuery()
}

const dialogVisible = ref(false)
const dialogTitle = ref('')
const formLoading = ref(false)
const formType = ref('')
const formData = ref<ReviewApi.ReviewVO>({
  id: undefined,
  shopId: undefined,
  orderId: undefined,
  memberId: undefined,
  rating: 5,
  content: '',
  images: '',
  reply: '',
  replyTime: undefined,
  status: 0,
  createTime: undefined as any
})
const formRules = reactive({
  shopId: [{ required: true, message: '店铺不能为空', trigger: 'change' }],
  rating: [{ required: true, message: '评分不能为空', trigger: 'change' }],
  content: [{ required: true, message: '评价内容不能为空', trigger: 'blur' }]
})
const formRef = ref()

const openForm = async (type: string, id?: string | number) => {
  dialogVisible.value = true
  dialogTitle.value = t('action.' + type)
  formType.value = type
  resetForm()
  if (id) {
    formLoading.value = true
    try {
      formData.value = await ReviewApi.getReview(id)
    } finally {
      formLoading.value = false
    }
  }
}

const submitForm = async () => {
  if (!formRef) return
  const valid = await formRef.value.validate()
  if (!valid) return
  formLoading.value = true
  try {
    const data = formData.value
    if (formType.value === 'create') {
      await ReviewApi.createReview(data)
      message.success(t('common.createSuccess'))
    } else {
      await ReviewApi.updateReview(data)
      message.success(t('common.updateSuccess'))
    }
    dialogVisible.value = false
    await getList()
  } finally {
    formLoading.value = false
  }
}

const resetForm = () => {
  formData.value = {
    id: undefined,
    shopId: 0,
    orderId: undefined,
    memberId: undefined,
    rating: 5,
    content: '',
    images: '',
    reply: '',
    replyTime: undefined,
    status: 0,
    createTime: undefined as any
  }
  formRef.value?.resetFields()
}

const handleDelete = async (id: string | number) => {
  try {
    await message.delConfirm()
    await ReviewApi.deleteReview(id)
    message.success(t('common.delSuccess'))
    await getList()
  } catch {}
}

// 回复弹窗
const replyDialogVisible = ref(false)
const replyLoading = ref(false)
const replyForm = reactive({
  id: 0,
  content: '',
  reply: ''
})

const openReplyForm = (row: any) => {
  replyForm.id = row.id
  replyForm.content = row.content
  replyForm.reply = ''
  replyDialogVisible.value = true
}

const submitReply = async () => {
  if (!replyForm.reply) {
    message.warning('请输入回复内容')
    return
  }
  replyLoading.value = true
  try {
    await ReviewApi.replyReview(replyForm.id, replyForm.reply)
    message.success('回复成功')
    replyDialogVisible.value = false
    await getList()
  } finally {
    replyLoading.value = false
  }
}

onMounted(() => {
  getList()
  getShopList()
})
</script>
